import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState("system");

  // Ye mapping backend ke integer values se match karta hai
  const themeMap = {
    system: 0,
    light: 1,
    dark: 2,
  };

  const reverseThemeMap = {
    0: "system",
    1: "light",
    2: "dark",
  };

  useEffect(() => {
    axios.get("http://127.0.0.1:8000/settings/theme/1")
      .then((res) => {
        const themeInt = res.data.theme;
        setThemeMode(reverseThemeMap[themeInt] || "system");
      })
      .catch(() => {
        setThemeMode("system");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  const updateTheme = async (themeValue) => {
    setThemeMode(themeValue);
    try {
        await axios.put("http://127.0.0.1:8000/settings/theme1/1", {
          theme: themeMap[themeValue],
        });
      } catch (error) {
        console.error("Error updating theme:", error);
      }
    };

  return (
    <ThemeContext.Provider value={{ themeMode, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
